import { useState } from "react";
import { BRAND_ENUM } from "../../../models/Enums/BrandEnum";
import styles from "./BrandSelection.module.css";
import {
    Button,
    Dropdown,
    DropdownOption,
    Image,
    Typography,
} from "@volvo/vcdk-react";
import { UITEXT } from "../../../constants/const";
import brandImage from "../../../assets/BrandSelectionImage.jpg";

interface BrandSelectionProps {
    onBrandSelected: (brand: string) => void;
    onNext: () => void;
}

const BrandSelection: React.FC<BrandSelectionProps> = ({
    onBrandSelected,
    onNext,
}) => {
    const brandOptions = Object.entries(BRAND_ENUM).map(
        ([key, brandOptionsvalue]) => ({
            value: key,
            text: brandOptionsvalue,
        })
    );

    const [value, setValue] = useState<string | undefined>(undefined);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChange = (selected: any) => {
        const candidate = selected?.detail?.value ?? selected?.target?.value;
        const newValue =
            typeof candidate === "string" && candidate.trim() !== ""
                ? candidate
                : undefined;
        setValue(newValue);
    };

    const handleNext = () => {
        if (value) {
            onBrandSelected(value);
            onNext();
        }
    };

    return (
        <div className={styles.BrandSelection}>
            <div className={styles.BrandSelectionContent}>
                <div className={styles.ImageContainer}>
                    <Image
                        src={brandImage}
                        loading="lazy"
                        aspectRatio="1/1"
                        width={450}
                        height={500}
                    />
                </div>
                <div className={styles.TextContainer}>
                    <div>
                        <div className={styles.BrandSelectionTitle}>
                            <Typography variant="heading3">
                                {UITEXT.BrandLabel}
                            </Typography>
                            <Typography variant="caption1">
                                {UITEXT.BrandSelectionDescription}
                            </Typography>
                        </div>
                    </div>
                    <Dropdown
                        className={styles.BrandDropdown}
                        onChange={onChange}
                        multi={false}
                        size="medium"
                        floatingLabel={false}
                        placeholder="Select Brand"
                        clearable
                        value={value}
                        placement="bottom"
                    >
                        {brandOptions.map((option, option_index) => (
                            <DropdownOption
                                key={option_index}
                                value={option.value}
                            >
                                {option.text}
                            </DropdownOption>
                        ))}
                    </Dropdown>
                    <div className={styles.ButtonGroup}>
                        <Button
                            variant="primary"
                            size="large"
                            type="button"
                            onClick={handleNext}
                            disabled={!value}
                        >
                            Next
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandSelection;
